export default __webpack_public_path__ + "static/media/special.10809ce2.jpg";